import * as React from 'react';
import { Download, Warning } from '@mui/icons-material';

import { ExampleTable } from './ExampleTable';

export const Example: React.FC = () => {
  return (
    <div className="bg-blue-100 border border-gray-300 p-4 rounded-md">
      <h2>Example bill of lading bulk upload template</h2>
      <ExampleTable />
      <div className="bg-blue-200 flex gap-3 w-full p-3 text-gray-900 items-center">
        <Warning />
        <p className="text-sm">
          If you don&apos;t include a SCAC column, make sure all your Ocean BOLs have the SCAC
          prefix
        </p>
      </div>
      <div className="flex pt-5 gap-2 text-blue-900 underline items-center">
        <Download className="text-lg" />
        <a href="https://s3.us-west-1.amazonaws.com/erl-cdn.bluecargo.io/templates/BC+_+Bulk+Upload+BOL+Template.csv">
          Download bulk upload CSV template
        </a>
      </div>
    </div>
  );
};
Example.displayName = 'BulkUpload.Example';
